export class MiscModelCategory {
	public Category: string | null;
	public CategoryForDisplay: string | null;
	groups: string[];
}
